import type { StyleRule } from '@archipro-design/aria';
import { gridClassName, pxArrayToRem, pxToRem } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const Socials: StyleRule = ({ theme }) => ({
    [`& .${gridClassName}`]: {
        padding: pxArrayToRem([16, 0, 15, 0]),
        gap: pxArrayToRem([12, 16]),
    },

    [theme.screen.laptop]: {
        [`& .${gridClassName}`]: {
            columnGap: pxToRem(14),
        },
    },
});

export const Social: StyleRule = ({ theme }) => ({
    width: pxToRem(24),
    height: pxToRem(24),
    [`& .${svgIconClassName}`]: {
        width: '100%',
        height: '100%',
        '& svg': {
            width: '100%',
            height: '100%',
            fill: theme.siteVariables.colorScheme.default!.foreground,
            '&:hover': {
                fill: theme.siteVariables.colorScheme.default!.foregroundHover,
            },
        },
    },
    [theme.screen.laptop]: {
        width: pxToRem(24),
        height: pxToRem(24),
    },
});
